import { render, staticRenderFns } from "./DividerPage.vue?vue&type=template&id=ac3f6f0a"
import script from "./DividerPage.vue?vue&type=script&lang=js"
export * from "./DividerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports